import { styled } from '@linaria/react';

export const StyledImage = styled.img`
  -webkit-touch-callout: none;
  user-select: none;
  -webkit-user-drag: none;
`;
